import React from 'react'

const SvgFeature3En = props => (
  <svg id='feature3_en_svg__\u56FE\u5C42_1' x={0} y={0} viewBox='0 0 730 480' xmlSpace='preserve' {...props}>
    <style>
      {
        '.feature3_en_svg__st0{fill:#8796aa}.feature3_en_svg__st1{fill:#f4f8fa;stroke:#dae0e5;stroke-miterlimit:10}.feature3_en_svg__st2{font-family:&apos;MyriadPro-Regular&apos;}.feature3_en_svg__st3{font-size:12px}.feature3_en_svg__st4{fill:#fd5c1f}.feature3_en_svg__st5{font-family:&apos;SourceHanSansCN-Medium-GBpc-EUC-H&apos;}.feature3_en_svg__st6{font-size:16px}.feature3_en_svg__st7{fill:#00b5b0}.feature3_en_svg__st8{fill:#252a3a}.feature3_en_svg__st10,.feature3_en_svg__st9{fill:none;stroke:#8796aa;stroke-miterlimit:10;stroke-dasharray:4,4}.feature3_en_svg__st10{stroke-dasharray:3,3}'
      }
    </style>
    <path
      className='feature3_en_svg__st0'
      d='M648.26 35.27h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-3 4h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm5 5h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm6-1h-1v1h-1v1h2v-2zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-4v1h3v3h1v-4zM656.26 314.22h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-8 0h-4v1h4v-1zm-3 4h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm0 8h-1v4h1v-4zm7 3h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm8 0h-4v1h4v-1zm4-3h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4zm0-8h-1v4h1v-4z'
    />
    <path className='feature3_en_svg__st1' d='M96.01 54.07h180v60h-180z' />
    <path className='feature3_en_svg__st0' d='M280.76 83.07h162v2h-162z' />
    <path className='feature3_en_svg__st0' d='M442.18 78.07l8 6-8 6M157.05 352.52h85v2h-85z' />
    <path className='feature3_en_svg__st0' d='M241.47 347.52l8 6-8 6' />
    <path
      transform='rotate(-8.163 329.311 424.06)'
      className='feature3_en_svg__st0'
      d='M154.82 423.07h349.01v2H154.82z'
    />
    <path className='feature3_en_svg__st0' d='M500.64 393.4l8.77 4.8-7.07 7.08M122.76 384.52h2v34h-2z' />
    <path className='feature3_en_svg__st0' d='M129.76 417.94l-6 8-6-8M164.47 370.52h85v2h-85z' />
    <path className='feature3_en_svg__st0' d='M165.05 365.52l-8 6 8 6' />
    <text
      transform='translate(4.805 317.296)'
      className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
    >
      {'Sending Host'}
    </text>
    <text
      transform='translate(289.945 18.295)'
      className='feature3_en_svg__st4 feature3_en_svg__st5 feature3_en_svg__st6'
    >
      {'Checkpoint Resend'}
    </text>
    <text
      transform='translate(304.665 298.296)'
      className='feature3_en_svg__st4 feature3_en_svg__st5 feature3_en_svg__st6'
    >
      {'Retransmission'}
    </text>
    <text
      transform='translate(654.32 317.296)'
      className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
    >
      {'Receiving Host'}
    </text>
    <text
      transform='translate(332.966 172.555)'
      className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
    >
      {'Send Request'}
    </text>
    <text
      transform='translate(334.065 72.555)'
      className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
    >
      {'Sending Flies'}
    </text>
    <text
      transform='translate(139.245 88.066)'
      className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
    >
      {'File A'}
    </text>
    <text
      transform='translate(226.245 88.066)'
      className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
    >
      {'File B'}
    </text>
    <path
      className='feature3_en_svg__st0'
      d='M9.59 262.48h53.33v34.17h2.5v-33.68c0-1.65-1.34-2.99-2.99-2.99H10.08c-1.65 0-2.99 1.34-2.99 2.99v33.68h2.5v-34.17z'
    />
    <path
      className='feature3_en_svg__st0'
      d='M.42 296.64c0 1.84 1.49 3.33 3.33 3.33h65c1.84 0 3.33-1.49 3.33-3.33H.42z'
    />
    <path
      className='feature3_en_svg__st7'
      d='M43.24 275.61c-.52-2.86-3.01-5.03-6.02-5.03-2.37 0-4.53 1.37-5.54 3.52-2.73-.1-5.01 2.04-5.11 4.77-.1 2.73 2.04 5.01 4.77 5.11h.89l.72-2.59-1.75-1.61 7.34-5.07-4.71 15.88 7.55-4.92-1.88-1.7 2.87.01h.16a4.224 4.224 0 004.06-4.38 4.212 4.212 0 00-3.35-3.99z'
    />
    <path
      className='feature3_en_svg__st0'
      d='M664.08 262.48h53.33v34.17h2.5v-33.68c0-1.65-1.34-2.99-2.99-2.99h-52.35c-1.65 0-2.99 1.34-2.99 2.99v33.68h2.5v-34.17z'
    />
    <path
      className='feature3_en_svg__st0'
      d='M654.92 296.64c0 1.84 1.49 3.33 3.33 3.33h65c1.84 0 3.33-1.49 3.33-3.33h-71.66z'
    />
    <path
      className='feature3_en_svg__st7'
      d='M698.75 276.98c-.34 0-.68.03-1 .08v-.08c0-3.87-3.13-7-7-7-3.17 0-5.85 2.11-6.71 5.01-.1 0-.19-.01-.29-.01-3.87 0-7 3.13-7 7s3.13 7 7 7h6.12v-6.73l-3.62 3.73-1.5-1.6 6-6.4 6 6.4-1.5 1.6-3.62-3.73v6.73h6.12v-.08c.33.05.66.08 1 .08 3.31 0 6-2.69 6-6s-2.68-6-6-6z'
    />
    <path
      className='feature3_en_svg__st4'
      d='M371.1 114.45c-2.91 0-5.81.56-8.37 1.19l1.89 1.36c-2.55.48-5.16.34-6.59.02v5.57c1.94.51 8.33.14 11.13-1.01l-.88-1.06c1.03-.1 1.73-.12 2.81-.12 2.98 0 5.81.41 8.37 1.16v-5.92c-2.41-.6-5.45-1.19-8.36-1.19z'
    />
    <path
      className='feature3_en_svg__st8'
      d='M379.98 136.06c-1.95.2-3.32.52-4.7.92v1.64c-2.16.49-5.65.97-8.46.79-2.9-.18-6.65-1.23-8.27-1.85v-5.89c2.29 1.22 6.63 2.04 10.21 2.04 1.99 0 4.44-.26 5.88-.56l-.28-1.47c1.83-.63 2.97-1.16 5.64-1.42v5.8h-.02zM376.32 122.68c-2.03 0-5 .47-5.84.7l.97 1.56c-2.19.55-4.37.54-5.97.54-3.76 0-6.95-.79-10.27-2.06v5.9c2.55.87 5.82 1.54 8.93 1.54s6.51-.42 9.42-1.43l-.27-.72c1.01-.13 1.88-.19 2.99-.19 2.09 0 3.84.07 6.02.59v-5.92c-1.21-.25-3.95-.51-5.98-.51z'
    />
    <path
      className='feature3_en_svg__st0'
      d='M370.66 103.95c11.09.96 19.95 9.82 20.91 20.91h2.01c-.97-12.19-10.72-21.94-22.91-22.91v2h-.01zM345.76 124.86c.96-11.09 9.82-19.95 20.91-20.91v-2.01c-12.19.97-21.94 10.72-22.91 22.91h2v.01zM366.66 149.77c-11.09-.96-19.95-9.82-20.91-20.91h-2.01c.97 12.19 10.72 21.94 22.91 22.91v-2h.01zM391.57 128.86c-.96 11.09-9.82 19.95-20.91 20.91v2.01c12.19-.97 21.94-10.72 22.91-22.91l-2-.01z'
    />
    <path
      className='feature3_en_svg__st4'
      d='M126.31 72.07h-14.25v24h19.86V77.23l-5.61-5.16zm-12.59 22.35V73.73h10.76v4.97h5.79v15.72h-16.55z'
    />
    <path
      className='feature3_en_svg__st4'
      d='M115.37 82.01h7.73v1.66h-7.73zM115.37 86.14h12.41v1.66h-12.41zM115.37 90.28h12.41v1.66h-12.41zM214.31 72.07h-14.25v24h19.86V77.23l-5.61-5.16zm-12.59 22.35V73.73h10.76v4.97h5.79v15.72h-16.55z'
    />
    <path
      className='feature3_en_svg__st4'
      d='M203.37 82.01h7.73v1.66h-7.73zM203.37 86.14h12.41v1.66h-12.41zM203.37 90.28h12.41v1.66h-12.41z'
    />
    <path className='feature3_en_svg__st1' d='M457.01 54.07h180v60h-180z' />
    <text
      transform='translate(502.245 88.066)'
      className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
    >
      {'File A'}
    </text>
    <text
      transform='translate(547.245 88.329)'
      className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
    >
      {'File B is missing'}
    </text>
    <path
      className='feature3_en_svg__st4'
      d='M487.31 72.07h-14.25v24h19.86V77.23l-5.61-5.16zm-12.59 22.35V73.73h10.76v4.97h5.79v15.72h-16.55z'
    />
    <path
      className='feature3_en_svg__st4'
      d='M476.37 82.01h7.73v1.66h-7.73zM476.37 86.14h12.41v1.66h-12.41zM476.37 90.28h12.41v1.66h-12.41z'
    />
    <path className='feature3_en_svg__st1' d='M96.01 156.07h180v60h-180z' />
    <path className='feature3_en_svg__st0' d='M281.76 185.07h162v2h-162z' />
    <path className='feature3_en_svg__st0' d='M443.18 180.07l8 6-8 6' />
    <text
      transform='translate(336.359 206.555)'
      className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
    >
      {'Resend Files'}
    </text>
    <text
      transform='translate(140.245 190.066)'
      className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
    >
      {'File A'}
    </text>
    <text
      transform='translate(98.245 245.066)'
      className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
    >
      {'Send completed'}
    </text>
    <g>
      <text
        transform='translate(97.245 340.067)'
        className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
      >
        {'Sending Files'}
      </text>
    </g>
    <g>
      <text
        transform='translate(183.245 393.067)'
        className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
      >
        {'Error over'}
      </text>
    </g>
    <g>
      <text
        transform='translate(209.245 247.066)'
        className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
      >
        {'Resend'}
      </text>
    </g>
    <g>
      <text
        transform='translate(227.245 190.066)'
        className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
      >
        {'File B'}
      </text>
    </g>
    <g>
      <path
        className='feature3_en_svg__st4'
        d='M127.31 174.07h-14.25v24h19.86v-18.85l-5.61-5.15zm-12.59 22.35v-20.69h10.76v4.97h5.79v15.72h-16.55z'
      />
      <path
        className='feature3_en_svg__st4'
        d='M116.37 184.01h7.73v1.66h-7.73zM116.37 188.14h12.41v1.66h-12.41zM116.37 192.28h12.41v1.66h-12.41z'
      />
    </g>
    <g>
      <path
        className='feature3_en_svg__st4'
        d='M128.31 353.07h-14.25v24h19.86v-18.85l-5.61-5.15zm-12.59 22.35v-20.69h10.76v4.97h5.79v15.72h-16.55z'
      />
      <path
        className='feature3_en_svg__st4'
        d='M117.37 363.01h7.73v1.66h-7.73zM117.37 367.14h12.41v1.66h-12.41zM117.37 371.28h12.41v1.66h-12.41z'
      />
    </g>
    <g>
      <path
        className='feature3_en_svg__st4'
        d='M128.31 435.07h-14.25v24h19.86v-18.85l-5.61-5.15zm-12.59 22.35v-20.69h10.76v4.97h5.79v15.72h-16.55z'
      />
      <path
        className='feature3_en_svg__st4'
        d='M117.37 445.01h7.73v1.66h-7.73zM117.37 449.14h12.41v1.66h-12.41zM117.37 453.28h12.41v1.66h-12.41z'
      />
    </g>
    <g>
      <path
        className='feature3_en_svg__st0'
        d='M215.31 174.07h-14.25v24h19.86v-18.85l-5.61-5.15zm-12.59 22.35v-20.69h10.76v4.97h5.79v15.72h-16.55z'
      />
      <path
        className='feature3_en_svg__st0'
        d='M204.37 184.01h7.73v1.66h-7.73zM204.37 188.14h12.41v1.66h-12.41zM204.37 192.28h12.41v1.66h-12.41z'
      />
    </g>
    <path className='feature3_en_svg__st1' d='M457.01 156.07h180v60h-180z' />
    <g>
      <text
        transform='translate(499.245 190.066)'
        className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
      >
        {'File A'}
      </text>
    </g>
    <g>
      <text
        transform='translate(592.245 190.066)'
        className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
      >
        {'File B'}
      </text>
    </g>
    <g>
      <path
        className='feature3_en_svg__st4'
        d='M488.31 174.07h-14.25v24h19.86v-18.85l-5.61-5.15zm-12.59 22.35v-20.69h10.76v4.97h5.79v15.72h-16.55z'
      />
      <path
        className='feature3_en_svg__st4'
        d='M477.37 184.01h7.73v1.66h-7.73zM477.37 188.14h12.41v1.66h-12.41zM477.37 192.28h12.41v1.66h-12.41z'
      />
    </g>
    <g>
      <path
        className='feature3_en_svg__st0'
        d='M582.31 174.07h-14.25v24h19.86v-18.85l-5.61-5.15zm-12.59 22.35v-20.69h10.76v4.97h5.79v15.72h-16.55z'
      />
      <path
        className='feature3_en_svg__st0'
        d='M571.37 184.01h7.73v1.66h-7.73zM571.37 188.14h12.41v1.66h-12.41zM571.37 192.28h12.41v1.66h-12.41z'
      />
    </g>
    <path className='feature3_en_svg__st1' d='M515.14 364.22h120v60h-120z' />
    <g>
      <text
        transform='translate(557.245 398.067)'
        className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
      >
        {'Receving Files'}
      </text>
    </g>
    <g>
      <path
        className='feature3_en_svg__st0'
        d='M545.31 382.22h-14.25v24h19.86v-18.85l-5.61-5.15zm-12.59 22.35v-20.69h10.76v4.97h5.79v15.72h-16.55z'
      />
      <path
        className='feature3_en_svg__st0'
        d='M534.37 392.15h7.73v1.66h-7.73zM534.37 396.29h12.41v1.66h-12.41zM534.37 400.43h12.41v1.66h-12.41z'
      />
    </g>
    <path className='feature3_en_svg__st4' d='M556.26 185.02h-8v-8h-1v8h-8v1h8v8h1v-8h8z' />
    <path className='feature3_en_svg__st0' d='M399.82 123.98l5.95 1.36-2.63-6.49z' />
    <path className='feature3_en_svg__st9' d='M471.26 95.02l-69.49 28.44' />
    <g>
      <path className='feature3_en_svg__st0' d='M263.82 165.98l5.95 1.36-2.63-6.49z' />
      <path className='feature3_en_svg__st9' d='M335.26 137.02l-69.49 28.44' />
    </g>
    <g>
      <path className='feature3_en_svg__st10' d='M137.26 202.27v27' />
    </g>
    <path className='feature3_en_svg__st10' d='M227.26 202.27v27' />
    <path
      className='feature3_en_svg__st4'
      d='M269.52 349.43c-6.62 0-12 5.38-12 12s5.38 12 12 12 12-5.38 12-12-5.39-12-12-12zm0 22.59c-1.47 0-3.01-1.81-3.91-4.81 1.22.21 2.53.33 3.91.33s2.69-.12 3.91-.33c-.9 3-2.44 4.81-3.91 4.81zm0-5.9c-1.57 0-3.01-.15-4.29-.41-.26-1.28-.41-2.72-.41-4.29 0-1.57.15-3.01.41-4.29 1.28-.26 2.72-.41 4.29-.41 1.57 0 3.01.15 4.29.41.26 1.28.41 2.72.41 4.29 0 1.57-.15 3.01-.41 4.29-1.29.26-2.73.41-4.29.41zm-5.79-.78c-3-.9-4.81-2.44-4.81-3.91s1.81-3.01 4.81-3.91c-.21 1.22-.33 2.53-.33 3.91s.13 2.69.33 3.91zm5.79-14.5c1.47 0 3.01 1.81 3.91 4.81-1.22-.21-2.53-.33-3.91-.33s-2.69.12-3.91.33c.89-3 2.43-4.81 3.91-4.81zm5.78 6.68c3 .9 4.81 2.44 4.81 3.91s-1.81 3.01-4.81 3.91c.21-1.22.33-2.53.33-3.91s-.12-2.69-.33-3.91zm4.23.5c-1.13-.87-2.7-1.58-4.56-2.05-.47-1.86-1.18-3.43-2.05-4.56 3.1 1.06 5.56 3.51 6.61 6.61zm-13.42-6.61c-.87 1.13-1.58 2.7-2.05 4.56-1.86.47-3.43 1.18-4.56 2.05 1.06-3.1 3.51-5.55 6.61-6.61zm-6.61 13.42c1.13.87 2.7 1.58 4.56 2.05.47 1.86 1.18 3.43 2.05 4.56-3.1-1.05-5.55-3.51-6.61-6.61zm13.42 6.61c.87-1.13 1.58-2.7 2.05-4.56 1.86-.47 3.43-1.18 4.56-2.05a10.59 10.59 0 01-6.61 6.61z'
    />
    <g>
      <path
        className='feature3_en_svg__st0'
        d='M279.96 350.6c-.45-.58-.65-1.14-.58-1.68.02-.17.06-.3.12-.38s.13-.15.22-.2c.08-.05.2-.08.34-.08.15 0 .26.08.34.24l1.36 2.92c.39-.44.71-.79.97-1.06s.53-.54.82-.8.54-.48.77-.63c.23-.15.51-.31.85-.46.34-.15.62-.24.84-.26s.41.03.58.15c.17.12.29.26.36.43.07.17.06.35-.01.54s-.2.36-.36.51c-.17.15-.4.3-.68.45l-1.09.53c-.27.15-.6.35-.98.61s-.64.45-.77.58l-.52.5c.5.56.93 1.04 1.3 1.45.37.41.67.71.92.91.25.2.5.36.75.49s.45.18.61.15l.42-.06c.06.02.12.06.17.12.05.06.07.13.05.21-.03.08-.1.15-.22.21s-.23.09-.34.09c-.23.02-.51-.04-.82-.18s-.74-.44-1.29-.88c-.54-.44-.91-.76-1.09-.95l-.95-.92c-.51.6-.88 1.04-1.09 1.33s-.37.51-.47.68-.21.34-.32.52c-.11.18-.2.39-.27.62-.07.23-.15.35-.22.35-.08 0-.15-.05-.22-.16s-.11-.22-.11-.32 0-.22.03-.35.11-.36.24-.7c.13-.34.35-.77.65-1.29l.93-1.65c-.38-.47-.79-.99-1.24-1.58z'
      />
    </g>
    <g>
      <text
        transform='translate(254.26 393.4)'
        className='feature3_en_svg__st0 feature3_en_svg__st2 feature3_en_svg__st3'
      >
        {'Network Error'}
      </text>
    </g>
  </svg>
)

export default SvgFeature3En
